import React, {CSSProperties, useEffect, useState} from 'react';
import {handicaddieSelector} from "../services/store/asyncThunk";
import {UserService} from "../services/api/UserService";
import PencilIcon from "../icons/PencilIcon";
import {IconSize} from "../services/IconConstants";

interface Props {
    url?: string
    user?: string | 'current'
    size: 'xs' | 's' | 'smd' | 'md' | 'lg'
    style?: CSSProperties
    round?: boolean
    showEditWatermark?: boolean
}

const PLACEHOLDER_AVATAR = '/placeholder.png'

const Avatar = ({ url, user, size, style, round = true, showEditWatermark = false }: Props) => {

    const { userAvatar } = handicaddieSelector(state => state.session)
    const { getAvatar } = UserService();

    const [avatar, setAvatar] = useState<string>(PLACEHOLDER_AVATAR)

    useEffect(() => {
        if (url) {
            setAvatar(url)
            return
        }

        if (user === 'current') {
            if (userAvatar) {
                setAvatar(userAvatar)
            }
        } else {
            if (user) {
                loadUserAvatar(user)
            } else {
                setAvatar(PLACEHOLDER_AVATAR)
            }
        }
    }, [url, user, userAvatar])

    const loadUserAvatar = async (userId: string) => {
        setAvatar(PLACEHOLDER_AVATAR)
        const a = await getAvatar(userId)
        if (a.avatar) {
            setAvatar(a.avatar)
        }
    }

    let s = '1em'

    switch (size) {
        case "xs":
            s = '2em'
            break
        case "s":
            s = '5em'
            break
        case "smd":
            s = '7em'
            break
        case "md":
            s = '10em'
            break
        case "lg":
            s = '15em'
            break
    }

    const finalStyle: CSSProperties = {
        width: s,
        height: s,
        borderRadius: round ? s : '0',
        objectFit: 'cover',
        ...style
    }

    return (
        <div style={{ position: 'relative', width: s, height: s }}>
            <img
                src={avatar}
                style={finalStyle}
                draggable={false}
                alt="User Avatar"
            />
            {showEditWatermark && (
                <div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                        backgroundColor: 'var(--color-primary)',
                        borderRadius: '50%',
                        padding: '0.5em',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 0 2px rgba(0,0,0,0.3)'
                    }}
                >
                    <PencilIcon size={IconSize.sm} style={{ color: 'var(--text-on-primary)' }} />
                </div>
            )}
        </div>
    )
}

export default Avatar;
